<template>
<header id="header" :class="[{'is-white': is_white}, {'is-menu-toggled': mobile_menu_is_active}]">
    <nav class="navbar is-transparent">
        <div class="navbar-brand">
            <h1 :class="['navbar-item']" v-if="site_data.pagetype == 'HomePage'">
                <a @click.prevent="scroll_to_anchor('home')" id="logo" rel="start" href="/"><img class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" :alt="site_data.siteconfig.title" /><template v-else>Leo Chen</template></a>
            </h1>
            <router-link :class="['navbar-item']" id="logo" rel="start" v-else :to="'/'"><img class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" :alt="site_data.siteconfig.title" /><template v-else>Leo Chen</template></router-link>
            <div v-on:click="show_mobile_menu" :class="{'navbar-burger': true, 'burger': true, 'is-active': mobile_menu_is_active}" data-target="mobile-menu">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div id="mobile-menu" :class="{'navbar-menu': true, 'is-active': mobile_menu_is_active}">
            <div class="navbar-end">
                <template v-if="$route.path == '/'">
                    <a @click.prevent="scroll_to_anchor(item.target)" :class="['navbar-item', {'is-active': item.target == current_active}]" v-for="item, i in navigation" :key="i" :href="item.url">{{item.label}}</a>
                </template>
                <template v-else>
                    <router-link class="navbar-item" v-for="item, i in navigation" :key="i" :to="item.url">{{item.label}}</router-link>
                </template>
            </div>
        </div>
    </nav>
</header>
</template>
<script>
export default {
    name: 'Header',
    props: ['site_data', 'is_mobile'],
    data()
    {
        return {
            scrolled_list           :   [],
            is_white                :   false,
            mobile_menu_is_active   :   false,
            navigation              :   this.site_data ? this.site_data.navigation : []
        }
    },
    created()
    {
        this.$bus.$on('onWindowScroll', this.scroll_handler);
        this.$bus.$on('scrollTo', this.scroll_to_anchor);
        this.$bus.$on('onActivySectionChange', this.handle_section_change);
    },
    beforeDestory()
    {
        this.$bus.$off('onWindowScroll', this.scroll_handler);
        this.$bus.$off('scrollTo', this.scroll_to_anchor);
        this.$bus.$off('onActivySectionChange', this.handle_section_change);
    },
    computed    :   {
        current_active()
        {
            if (this.scrolled_list.length) {
                return this.scrolled_list[this.scrolled_list.length - 1];
            }

            return 'home';
        }
    },
    methods: {
        handle_section_change(section, action)
        {
            if (action == 'push') {
                if (!this.scrolled_list.includes(section)) {
                    this.scrolled_list.push(section);
                }
            } else {
                let i   =   this.scrolled_list.indexOf(section);
                if (i >= 0) {
                    this.scrolled_list.splice(i, 1);
                }
            }
        },
        scroll_to_anchor(target)
        {
            let anchor  =   $('[data-anchor="' + target + '"]');
            if (anchor.length) {
                $.scrollTo(anchor, 500, {axis: 'y'});
            }

            this.mobile_menu_is_active = false;
            $(window).unbind('mousedown', this.click_to_close);
        },
        scroll_handler(offset)
        {
            this.is_white   =   offset > 70;
        },
        click_to_close: function(e) {
            let target = $(e.target);
            if (!target.is('.burger') &&
                target.parents('.burger').length == 0 &&
                !target.is('.navbar-item') &&
                target.parents('.navbar-item').length == 0) {

                this.mobile_menu_is_active = false;
                $(window).unbind('mousedown', this.click_to_close);
            }
        },
        show_mobile_menu: function(e) {
            e.preventDefault();
            $(window).unbind('mousedown', this.click_to_close).on('mousedown', this.click_to_close);
            this.mobile_menu_is_active = !this.mobile_menu_is_active;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Header.vue